(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'jquery', 'torso/modules/ServiceCell', 'services/messageExtService'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var messageExtService = require('./../urls').messageExtService;
    module.exports = factory(require('underscore'), require('jquery'), require('backbone-torso/modules/ServiceCell'), messageExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(_, $, TorsoService, messageExtService) {
  'use strict';

  /**
   * Singleton service for managing messages
   *
   * @class messageService
   * @static
   * @extends Torso.ServiceCell
   */
  return new (TorsoService.extend({
    /**
     * @method initialize
     * @override
     */
    initialize: function() {
      this.__idsCache = {};
    },

    /**
     * Get a criteria object which should return a particular appointment for a given patient
     * @method getCriteriaForAppointmentIdAndExternalId
     * @param patientVecnaId {String} vecnaId of the patient owning the appointment
     * @param appointmentExternalIds {String|String[]} externalId(s) of the appointment
     * @return {Object} criteria object
     */
    getCriteriaForAppointmentIdAndExternalId: function (patientVecnaId, appointmentExternalIds) {
      if (!_.isArray(appointmentExternalIds)) {
        appointmentExternalIds = [ appointmentExternalIds ];
      }
      return {
        appointmentCriteria: {
          externalAppointmentCriteria: {
            externalIds: appointmentExternalIds
          }
        },
        vecnaIds: [patientVecnaId]
      };
    },

    /**
     * Fetches message ids by message criteria
     * @method fetchMessageIdsByCriteria
     * @param [messageCriteria] {Object} message criteria
     * @return {Deferred} Promise from ajax request
     */
    fetchMessageIdsByCriteria: function (messageCriteria) {
      var messageService = this;
      var cachedResult = messageService.__getCachedResult(messageCriteria);
      if (!_.isUndefined(cachedResult)) {
        var deferredResult = $.Deferred();
        return deferredResult.resolve(cachedResult).promise();
      }
      return $.ajax({
        url: messageExtService + '/ids/criteria',
        contentType: 'application/json',
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(messageCriteria)
      }).then(function(result) {
        messageService.__cacheResult(messageCriteria, result);
        return result;
      });
    },

    /**
     * @method __getCachedResult
     * @param messageCriteria
     * @private
     */
    __getCachedResult: function(messageCriteria) {
      var cacheKey = this.__createCacheKey(messageCriteria);
      if (!_.isUndefined(cacheKey)) {
        return this.__idsCache[cacheKey];
      }
    },

    /**
     * @method __cacheResult
     * @param messageCriteria
     * @param result
     * @private
     */
    __cacheResult: function(messageCriteria, result) {
      var cacheKey = this.__createCacheKey(messageCriteria);
      if (!_.isUndefined(cacheKey)) {
        this.__idsCache[cacheKey] = result;
      }
    },

    /**
     * @method __createCacheKey
     * @param messageCriteria {Object} the criteria to generate a hash for.
     * @return {String|undefined} a unique key suitable for saving in a local cache.  Undefined if it should not be cached.
     * @private
     */
    __createCacheKey: function(messageCriteria) {
      // Only cache when retrieving a single appointment by external id.

      var cleanedMessageCriteria = _.omit(messageCriteria, 'vecnaIds');
      var messageCriteriaMessageTypesRetrieved = _.keys(cleanedMessageCriteria);
      if (messageCriteriaMessageTypesRetrieved.length !== 1
          || messageCriteriaMessageTypesRetrieved[0] !== 'appointmentCriteria') {
        return undefined;
      }

      var appointmentCriteria = messageCriteria.appointmentCriteria;
      var appointmentCriteriaProperties = _.keys(appointmentCriteria);
      if (appointmentCriteriaProperties.length !== 1
          || appointmentCriteriaProperties[0] !== 'externalAppointmentCriteria') {
        return undefined;
      }

      var externalAppointmentCriteria = appointmentCriteria.externalAppointmentCriteria;
      var externalAppointmentCriteriaProperties = _.keys(externalAppointmentCriteria);
      if (externalAppointmentCriteriaProperties.length !== 1
          || externalAppointmentCriteriaProperties[0] !== 'externalIds') {
        return undefined;
      }

      if (externalAppointmentCriteria.externalIds.length !== 1) {
        return undefined;
      }

      var appointmentExternalId = externalAppointmentCriteria.externalIds[0];
      return 'appointment-extId-' + appointmentExternalId;
    }
  }))();
}));
